<template>
    <div class="scee1">
        <!-- 搜索关键字 -->
        <div v-if="showgoodsList == 1">
            <template v-for="(item, index) in returnListArray">
                <div class="new-search-type-item">
                    <div>{{ item.title }}：</div>
                    <div>
                        <div>
                            <el-input v-model.trim="ctrl_keyword[item.type]" style="width: 200px" type="text" 
                            :placeholder="`请输入${item.title}`" size="mini" 
                            @keyup.enter.native="inputChange(ctrl_keyword[item.type],item.type)" @input="inputInput($event,item.type)">
                                <i @click="inputChange(ctrl_keyword[item.type],item.type)" class="el-icon-search el-input__icon" slot="suffix"> </i>
                            </el-input>
                            <el-button type="primary" size="mini" @click="inputChange('',item.type,true)">全部</el-button>
                        </div>
                        <div>
                            <ul :class="ctrl_expand[item.type] ? 'ul_default' : ''">
                                <template v-for="(item1, index) in item.list">
                                    <li :class="[{ li_checked: ctrl_checked[item.type] === item1 }]" 
                                        @click="listCheck(item.type,item1)">
                                        <span>{{ item1 }}</span>
                                    </li>
                                </template>
                            </ul>
                            <div>
                                <span @click="listExpand(item.type)">{{ ctrl_expand[item.type] ? "展开" : "收起" }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { highLightTableMsg } from "../filter"
export default {
    name: "PcScreenList1",
    props: {
        first_child_listtype: {
            type: Array,
            default: () => []
        },
        keyword: {
            type: String,
            default: ""
        },
        // catewords: {
        //     type: Array,
        //     default: () => []
        // },
        filters: {
            type: Object,
            default: () => ({})
        },
        factory: {
            type: Array,
            default: () => []
        },
        companyArr: {
            type: Array,
            default: () => []
        },
        spec: {
            type: Array,
            default: () => []
        },
        brand: {
            type: Array,
            default: () => []
        },
        dosage_form: {
            type: Array,
            default: () => []
        },
        first_index_active: {
            type: Number,
            default: 0
        },
        first_index: {
            type: Number,
            default: 0
        },
        factory_index: {
            type: String,
            default: ""
        },
        factory_collapse: {
            type: Boolean,
            default: true
        },
        spec_collapse: {
            type: Boolean,
            default: true
        },
        spec_index: {
            type: String,
            default: ""
        },
        brand_collapse: {
            type: Boolean,
            default: true
        },
        brand_index: {
            type: String,
            default: ""
        },
        dosage_form_collapse: {
            type: Boolean,
            default: true
        },
        company_name_collapse: {
            type: Boolean,
            default: true
        },
        company_name_index: {
            type: String,
            default: ""
        },
        dosage_form_index: {
            type: String,
            default: ""
        },
        streamer: {
            type: Array,
            default: () => []
        },
        showgoodsList: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            // 存储传递进来的数组
            ctrl_list:{
                factory:[],
                spec:[],
                brand:[],
                dosage_form:[],
                company_name:[]
            },
            // 控制选中下标
            ctrl_checked:{
                factory:'',
                spec:'',
                brand:'',
                dosage_form:'',
                company_name:''
            },
            // 控制展开收起
            ctrl_expand:{
                factory:true,
                spec:true,
                brand:true,
                dosage_form:true,
                company_name:true
            },
            // 控制关键字
            ctrl_keyword:{
                factory:"",
                spec:"",
                brand:"",
                dosage_form:"",
                company_name:""
            },
            // 存储输入的旧数据
            ctrl_old_keyword:{
                factory:"",
                spec:"",
                brand:"",
                dosage_form:"",
                company_name:""
            },
            highLightTableMsg,
            inptName: "",
            specificationInput: "",
            company_nameInput: "",
            inputtype: "",
            barndInput: "",
            factory_collapsetype: this.factory_collapse,
            spec_collapsetype: this.spec_collapse,
            dosage_form_collapsetype: this.dosage_form_collapse,
            brand_collapsetype: this.brand_collapse,
            company_name_collapsetype: this.company_name_collapse
        }
    },
    computed:{
        returnListArray(){
            let list = []
            if(this.factory.length > 0){
                list.push({
                    title:'厂家',
                    type:'factory',
                    list:this.ctrl_list.factory,
                })
            }   
            if(this.companyArr.length > 0){
                list.push({
                    title:'公司',
                    type:'company_name',
                    list:this.ctrl_list.company_name,
                })
            }   
            if(this.spec.length > 0){
                list.push({
                    title:'规格',
                    type:'spec',
                    list:this.ctrl_list.spec
                })
            }   
            if(this.brand.length > 0){
                list.push({
                    title:'品牌',
                    type:'brand',
                    list:this.ctrl_list.brand
                })
            }   
            if(this.dosage_form.length > 0){
                list.push({
                    title:'剂型',
                    type:'dosage_form',
                    list:this.ctrl_list.dosage_form
                })
            }      
            return list ;
        }
    },
    watch: {
        factory_collapse(vla) {
            this.factory_collapsetype = vla
        },
        spec_collapse(vla) {
            this.spec_collapsetype = vla
        },
        dosage_form_collapse(vla) {
            this.dosage_form_collapsetype = vla
        },
        brand_collapse(val) {
            this.brand_collapsetype = val
        },
        factory(val){
            this.ctrl_list.factory = val;
        },
        companyArr(val){
            this.ctrl_list.company_name = val;
        },
        spec(val){
            this.ctrl_list.spec = val;
        },  
        brand(val){ 
            this.ctrl_list.brand = val;
        },
        dosage_form(val){
            this.ctrl_list.dosage_form = val;
        }
    },
    mounted() { },

    methods: {
        onckicswich(url) {
            if (url) this.$router.pushToTab({ path: url })
        },
        setFiindextype(item) {
            this.$emit("setFiindex", item)
        },
        setFactorytype(factoryItem, f_index) {
            this.inptName = ""
            this.$emit("setFactory", factoryItem, f_index)
        },
        setCompanytype(companyItem, f_index) {
            this.companyInput_name = ""
            this.$emit("setCompany", companyItem, f_index)
        },
        setSpec(setSpecItem, f_index) {
            this.specificationInput = ""
            this.$emit("setSpec", setSpecItem, f_index)
        },
        setBrand(brandItem, f_index) {
            this.barndInput = ""
            this.$emit("setBrand", brandItem, f_index)
        },
        setDosageForm(dosageItem, d_index) {
            this.inputtype = ""
            this.$emit("setDosageForm", dosageItem, d_index)
        },
        changeinouttype(val, idnex) {
            let nameprm = {
                // category_id: 0,
                factory_index: this.inptName,
                factoryStr: this.inptName,
                // specStr: "",
                // dosageFormStr: "",
                inptName: this.inptName,
                factory_collapsetype: false
            }
            let company_name_obj = {
                // category_id: 0,
                // dosageFormStr: "",
                // factoryStr: "",
                company_name_index: this.companyInput_name,
                company_name: this.companyInput_name,
                company_name_collapsetype: false
            }
            let specification = {
                // category_id: 0,
                // dosageFormStr: "",
                // factoryStr: "",
                spec_index: this.specificationInput,
                specStr: this.specificationInput,
                spec_collapsetype: false
            }
            let dosage = {
                // category_id: 0,
                // factoryStr: "",
                // specStr: "",
                dosage_form_index: this.inputtype,
                dosageFormStr: this.inputtype,
                dosage_form_collapsetype: false
            }
            let category = {
                //    category_id :0,
                //    factoryStr : "",
                //    specStr : "",
                //    dosageFormStr:"",
                brand_index: this.barndInput,
                brandStr: this.barndInput,
                brand_collapsetype: false
            }
            switch (idnex) {
                case 1:
                    if (!this.inptName) {
                        nameprm.factory_collapsetype = true
                        nameprm.factory_index = ""
                    }
                    this.$emit("changeinout", nameprm, idnex)
                    break
                case 5:
                    if (!this.companyInput_name) {
                        company_name_obj.company_name_collapsetype = true
                        company_name_obj.company_name_index = ""
                    }
                    this.$emit("changeinout", company_name_obj, idnex)
                    break
                case 2:
                    if (!this.specificationInput) {
                        specification.spec_collapsetype = true
                        specification.spec_index = ""
                    }
                    this.$emit("changeinout", specification, idnex)
                    break
                case 3:
                    if (!this.inputtype) {
                        dosage.dosage_form_collapsetype = true
                        dosage.dosage_form_index = ""
                    }
                    this.$emit("changeinout", dosage, idnex)
                    break
                case 4:
                    if (!this.barndInput) {
                        category.brand_collapsetype = true
                        category.brand_index = ""
                    }
                    this.$emit("changeinout", category, idnex)
                    break
            }
        },
        collapse(val) {
            switch (val) {
                case 1:
                    this.factory_collapsetype = !this.factory_collapsetype
                    this.$emit("collapse", this.factory_collapsetype, val)
                    break
                case 2:
                    this.spec_collapsetype = !this.spec_collapsetype
                    this.$emit("collapse", this.spec_collapsetype, val)
                    break
                case 3:
                    this.brand_collapsetype = !this.brand_collapsetype
                    this.$emit("collapse", this.brand_collapsetype, val)
                    break
                case 4:
                    this.dosage_form_collapsetype = !this.dosage_form_collapsetype
                    this.$emit("collapse", this.dosage_form_collapsetype, val)
                    break
            }
        },
        // 对高亮进行封装
        highLight(item, highLight,bool) {
            return highLightTableMsg(item, highLight,bool)
        },
        inputInput(val,type){
            // 根据输入的内容，过滤掉ctrl_list中包含的内容
            if(val){
                this.ctrl_list[type] = this[type==='company_name'?'companyArr':type].filter(item => item.includes(val))
            }else{
                this.ctrl_list[type] = this[type==='company_name'?'companyArr':type]
            }
        },
        inputChange(val,type,bool=false){
            this.ctrl_keyword[type] = val;
            this.ctrl_checked[type] = '';
            this.searchList(type,val);
            if(bool&&val==''){
                this.ctrl_list[type] = this[type==='company_name'?'companyArr':type];
            }
        },
        listExpand(type){
            Object.keys(this.ctrl_expand).forEach(key => {
                if(key !== type){
                    this.ctrl_expand[key] = true
                }
            })
            this.ctrl_expand[type] = !this.ctrl_expand[type];
        },
        listCheck(type,item){
            this.ctrl_checked[type] = item;
            this.searchList(type,item);
        },
        searchList(type,val){
            if(val===this.ctrl_old_keyword[type]){
                return;
            }   
            this.ctrl_old_keyword[type] = val;
            // 保持原有数据传递
            switch(type){
                case 'factory':
                    let nameprm = {
                        factory_index: val,
                        factoryStr: val,
                        inptName: val
                    }
                    this.$emit("changeinout", nameprm, 1)
                    break;
                case 'company_name':
                    let company_name_obj = {
                        company_name_index: val,
                        company_name: val,
                        inptName: val
                    }
                    this.$emit("changeinout", company_name_obj, 5)
                    break;
                case 'spec':
                    let specification = {
                        spec_index: val,
                        specStr: val
                    }
                    this.$emit("changeinout", specification, 2)
                    break;
                case 'brand':
                    let category = {
                        brand_index: val,
                        brandStr: val
                    }
                    this.$emit("changeinout", category, 4)
                    break;
                case 'dosage_form':
                    let dosage = {
                        dosage_form_index: val,
                        dosageFormStr: val
                    }
                    this.$emit("changeinout", dosage, 3)
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.scee1 {
    width: 1200px;
    margin: 0 auto;
    padding: 0 10px;
}

.list-img {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-image {
        width: 400px;
        height: 100px;

        .img {
            width: 100%;
            height: auto;
        }
    }
}

.bias {
    margin: 0 4px;
}

.ul-height-30 {
    padding-right: 30px;
    max-height: 30px;
    transition: max-height 0.2s ease-out;
    overflow: hidden;
}

.ul-expand {
    padding-right: 30px;
    transition: max-height 0.2s ease-in;
    max-height: 500px;
    /*一个足够大的值*/
    overflow-y: auto;
}

.factory_selected {
    text-align: center;
    color: #fff !important;
    border: 1px solid #ff547b !important;
    padding: 1px;
    border-radius: 5px;
    background: #ff547b !important;
}

.spec_selected {
    text-align: center;
    color: #fff !important;
    border: 1px solid #ff547b !important;
    padding: 1px;
    border-radius: 5px;
    background: #ff547b !important;
}

.dosage_form__selected {
    text-align: center;
    color: #fff !important;
    border: 1px solid #ff547b !important;
    padding: 1px;
    border-radius: 5px;
    background: #ff547b !important;
}

.search-type-item {
    padding: 10px;
    font-size: 14px;
    display: flex;

    .title {
        flex-shrink: 0;
    }

    .search-content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .factory-search {
            width: 40%;
        }
        .alllef{
                    display: flex;
                    margin-right: 30px;
                   li{
                    &:nth-child(2) {
                        text-align: left !important;
                    }
                   }
        }
        .attr-list {
            position: relative;

            &:nth-child(2) {
                margin-top: 10px;
            }

            width: 100%;
            border: 1px solid #e5e5e5;
            border-radius: 4px;
            padding: 10px;

            ul {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                column-gap: 25px;
                grid-template-rows: minmax(20px, auto);
           
                li {
                    cursor: pointer;
                    //文字溢出显示省略号
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;
                    //margin: 0 20px;
                    flex-shrink: 0;
                    text-align: center;
                 

                    &:hover {
                        color: $base-color;
                    }

                    &.active {
                        color: $base-color;
                    }
                }
            }
        }

        .spec-list {
            ul {
                grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));

                li {
                    &:nth-child(1) {
                        text-align: left;
                    }
                }
            }
        }

        .dosage_form-list {
            ul {
                grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));
                li {
                    &:nth-child(1) {
                        text-align: left;
                    }
                }
            }
        }
    }

    .collapse-btn {
        position: absolute;
        right: 10px;
        top: 8px;
        cursor: pointer;
        text-align: right;
        font-size: 16px;
        font-weight: bold;
        color: $base-color;
        padding: 0 10px;
    }
}

// .goods-list {
//     background: #fff;
//     padding-top: 10px;
// }

.search_bread {
    display: inline-block;
    font-size: 14px;
    margin: 0px auto;
    width: 100%;
    padding: 10px;

    p {
        float: left;
    }

    li {

        float: left;
        padding: 0 10px;
    }

    .active a {
        color: white !important;
        border: 1px solid $base-color !important;
        padding: 5px;
        border-radius: 5px;
        background: $base-color !important;
    }
}

.categoryLevel2 {
    transform: translateY(10px);
}

.grid-container {
    flex: 1;
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
}

.categoryBox {
    padding: 10px 0;
    display: flex;
    margin-left: 10px;
}

.boxCategory {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 10px !important;
}

.boxactive {
    background-color: #ffffff;
    border: 1px solid $base-color !important;

    a {
        color: $base-color;
    }
}

.selected_border {
    border: 1px solid $base-color;
}

.attr_filter {
    .el-tag {
        margin-right: 5px;
        margin-bottom: 10px;
        border-radius: 0;

        .title {
            color: $base-color;
            font-size: 15px;
        }
    }
}

.category {
    margin: 0 auto 10px auto;
    border: 1px solid #eeeeee;

    .brand {
        border-bottom: 1px solid #eeeeee;
        display: flex;
        flex-direction: row;

        &:last-child {
            border-bottom: none;
        }

        .table_head {
            width: 140px;
            min-width: 140px;
            border-right: 1px solid #eeeeee;
            padding-left: 10px;
            padding-top: 10px;
            background-color: #f2f6fc;
        }

        .table_body {
            flex-grow: 1;

            .initial {
                margin: 5px auto 10px 10px;

                span {
                    border: 0;
                    margin: 0;
                    padding: 5px 10px;
                    border: 0;
                    border-radius: 0;

                    &:hover {
                        background-color: $base-color;
                        color: #ffffff;
                    }
                }
            }

            .content {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                padding: 10px;
                width: 900px;

                .brand-item {
                    margin-right: 10px;
                    margin-top: 10px;
                }

                .el-card {
                    width: 125px;
                    height: 45px;

                    &:hover {
                        border: 1px solid $base-color;
                        cursor: pointer;
                    }
                }

                span {
                    margin: auto 25px;
                }
            }
        }

        .table_op {
            margin-top: 5px;
            margin-right: 5px;
        }

        .el-image {
            width: 100%;
            height: 100%;
        }
    }
}

.empty {
    margin-top: 45px;
}

.pager {
    text-align: center;
    margin-top: 30px;
}

.new-search-type-item{
    display: flex;
    margin-bottom: 10px;
    >div:nth-child(1){
        padding-top: 10px;
        flex-shrink: 0;
        margin-right: 10px;
    }
    >div:nth-child(2){
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        gap: 10px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        >div:nth-child(1){
            display: flex;
            gap: 6px;
            border-bottom: 1px solid #e5e5e5;
            padding-bottom: 10px;
        }
        >div:nth-child(2){
            display: flex;
            justify-content: space-between;
            >ul{
                flex-grow: 1;
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 74px;
                overflow-y: auto;
                li{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    text-align: center;
                    cursor: pointer;
                    &:hover{
                        color: $base-color;
                    }
                    >span{
                        line-height: 16px;
                    }
                }
                .li_checked{
                    color: $base-color;
                }
            }
            // Ul的展开收起，默认显示一排，展开最多显示三排
            .ul_default{
                height: 25px !important;
                overflow-y: hidden !important;
            }
            >div{
                flex-shrink: 0;
                span{
                    cursor: pointer;
                    color: $base-color;
                }
            }
        }
    }
}
</style>
